import styled from './index.module.scss';
import { WorkArrowIcon, AmbassadorWorkIcon1, AmbassadorWorkIcon2, AmbassadorWorkIcon3, AmbassadorWorkIcon4 } from '@/components/UI/svg/Referral';
import { useReferralStore } from '@/components/Ambassador/ReferralProvider';
import { useGlobal } from '@/utils/useGlobal';
import QuestionIcon from '@/components/Ambassador/Common/QuestionIcon';
import { FC } from 'react';
import { signupCookie } from '@/utils/cookies/signupCookie';

interface IPorps {
    onRefer: () => void;
    isLogin: boolean;
}

const AmbassadorTipIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
        <g clipPath="url(#clip0_455_9420)">
            <path
                d="M8 15.75H3.5C3.30109 15.75 3.11032 15.671 2.96967 15.5303C2.82902 15.3897 2.75 15.1989 2.75 15V9C2.75 8.80109 2.82902 8.61032 2.96967 8.46967C3.11032 8.32902 3.30109 8.25 3.5 8.25H8L14.75 3V21L8 15.75Z"
                stroke="#707070"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M8 8.25V15.75" stroke="#707070" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M18.5 10.0171C18.9825 10.5649 19.2487 11.2699 19.2487 11.9999C19.2487 12.7299 18.9825 13.4349 18.5 13.9827"
                stroke="#707070"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M21.2812 7.5C22.3881 8.73755 23.0001 10.3397 23.0001 12C23.0001 13.6603 22.3881 15.2624 21.2812 16.5"
                stroke="#707070"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0_455_9420">
                <rect width="24" height="24" fill="white" transform="translate(0.5)" />
            </clipPath>
        </defs>
    </svg>
);

const HowWorks: FC<IPorps> = ({ onRefer, isLogin }) => {
    const { useLang, useRouter } = useGlobal();
    const { inBlackList } = useReferralStore();
    const router = useRouter();
    const { t } = useLang('referral');

    const list = [
        {
            icon: <AmbassadorWorkIcon1 />,
            title: t('works.title1'),
            desc: t('works.icondesc1'),
            btn: t('works.btn1'),
        },
        {
            icon: <WorkArrowIcon />,
        },
        {
            icon: <AmbassadorWorkIcon2 />,
            title: t('works.title2'),
            desc: t('works.icondesc2'),
            btn: t('works.btn2'),
            tips: t('works.tips2'),
        },
        {
            icon: <WorkArrowIcon />,
        },
        {
            icon: <AmbassadorWorkIcon3 />,
            title: t('works.title3'),
            desc: t.rich('works.icondesc3', {
                bold: (text: string) => <span className="bold">{text}</span>,
            }),
            tips: t('works.tips3'),
        },
        {
            icon: <WorkArrowIcon />,
        },
        {
            icon: <AmbassadorWorkIcon4 />,
            title: t('works.title4'),
            desc: t('works.icondesc4'),
            tips: t('works.tips4'),
        },
    ];

    const goLogin = (item: any) => {
        signupCookie({ sector_name: t('works.title'), entry_position: 4 });
        router.push({ pathname: '/login' });
    };

    return (
        <div className={`${styled.how_works}`}>
            {isLogin && (
                <div className="ambassador-tips">
                    <AmbassadorTipIcon />
                    <span>{t('ambassador_tips')}</span>
                </div>
            )}
            <h3 className="title">{t('works.title')}</h3>
            <ul className="icon_box">
                {list.map((item, index) => (
                    <li className={`item ${item.desc ? '' : 'arrow'}`} key={index}>
                        <div className="icon">{item.icon}</div>
                        <div className="text">
                            {item.title && (
                                <p className="step">
                                    {item.title}
                                    {item.tips && <QuestionIcon text={item.tips} />}
                                </p>
                            )}
                            <p className="desc">{item.desc}</p>
                            {item.btn && index == 0 && !isLogin && (
                                <span className="btn" onClick={() => goLogin(item)}>
                                    {item.btn}
                                </span>
                            )}
                            {item.btn && index == 2 && !inBlackList && (
                                <span className="btn" onClick={onRefer}>
                                    {item.btn}
                                </span>
                            )}
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default HowWorks;
